export const ADD_NEWS = 'ADD_NEWS';
export const DELETE_NEWS = 'DELETE_NEWS';
export const UPDATE_NEWS = 'UPDATE_NEWS';
export const FETCH_NEWS_REQUEST = 'FETCH_NEWS_REQUEST';